import { createAction, props } from '@ngrx/store';
import { UserProfile } from '../models/user-profile';

export const loadUserProfileSuccess = createAction('[User] Load User Success', props<{ userProfile: UserProfile }>());
export const loadUserProfileFail = createAction('[User] Load User Fail', props<{ error: unknown }>());
